import React, { Component, useEffect, useState, useCallback } from 'react';
import { useSelector, connect, useDispatch } from 'react-redux';
import { Helmet } from 'react-helmet';
import ga4 from 'react-ga4';
import styles from './styles.module.scss';

import apiLogin from '../../../api/Login';
import ApiReferral from '../../../api/Referral/ReferralApiFL';

import Menu from '../Menu';
import MiniCart from '../MiniCart';
import { SearchButton, SearchBox } from '../Search';
import { Navigation } from '../Navigation';
import { StoreSelectorButton, StoreSelectorModal } from '../StoreSelector';
import LinkLang from '../../Wraps/LinkLang';

import { ReactComponent as Logo } from '../../../assets/icons/logo-foreverliving.svg';
import { ReactComponent as MenuIcon } from '../../../assets/icons/icon-menu.svg';
import { ReactComponent as Mexico } from '../../../assets/icons/icon-mexico.svg';
import { ReactComponent as ArrowDown } from '../../../assets/icons/icon-arrow-down.svg';
import { ReactComponent as IconFBO } from '../../../assets/icons/icon-fbo.svg';
import Config, { spanish } from '../../../config/config';

import { getReferralFromURL } from '../../../redux/actions/referralFromUrl';

const Language = () => (
  <div className={styles.language}>
    <LinkLang to="/location">
      <Mexico />
      <b>{spanish ? 'México' : 'Mexico'}</b>
      <p>{spanish ? 'ES' : 'EN'}</p>
      <ArrowDown />
    </LinkLang>
  </div>
);

const FboStore = () => {
  const dispatch = useDispatch();
  const urlParams = new URLSearchParams(window.location.search);
  const fboReferalFromUrl = urlParams.get('fbo');
  const getReferralInfo = useCallback(async (fboReferalId) => {
    const payload = {
      Cliente: Config.api_services.client,
      Pais: 'MEX',
      Ambiente: Config.api_services.environment,
      IdFbo: fboReferalId,
    };
    const resp = await ApiReferral.validateReferral(payload);
    return resp;
  });

  useEffect(() => {
    const localFboStore = JSON.parse(sessionStorage.getItem('localFboStore'));
    if (localFboStore) {
      dispatch(
        getReferralFromURL(localFboStore.IdReferido, localFboStore.NombreFBO)
      );
    }
  }, []);

  useEffect(async () => {
    if (fboReferalFromUrl) {
      const respValidateReferal = await getReferralInfo(fboReferalFromUrl);
      if (
        respValidateReferal?.Codigo === 200 &&
        respValidateReferal.Respuesta
      ) {
        dispatch(
          getReferralFromURL(
            respValidateReferal.Respuesta[0].IdReferido,
            respValidateReferal.Respuesta[0].NombreFBO
          )
        );
        sessionStorage.setItem(
          'localFboStore',
          JSON.stringify(respValidateReferal.Respuesta[0])
        );
      }
    }
  }, []);
  return (
    <>
      <Helmet
        title="Forever Living | Tienda Online"
        meta={[
          {
            name: 'description',
            content: spanish
              ? 'Forever Living es el mayor productor, fabricante y distribuidor de Aloe Vera del mundo. Descubra los productos de Forever Living y aprenda más sobre cómo convertirse en propietario de un negocio para siempre aquí.'
              : 'Forever Living is the world’s largest grower, manufacturer and distributor of Aloe Vera. Discover Forever Living Products and learn more about becoming a forever business owner here.',
          },
        ]}
      />
    </>
  );
};

const FBO = ({ referralInfo }) => {
  const [popup, setPopup] = useState(false);
  const togglePopup = () => setPopup(!popup);
  const blurPopup = () => setPopup(false);
  return (
    <div className={styles.fbo}>
      <button type="button" onClick={togglePopup} onBlur={blurPopup}>
        <IconFBO />
      </button>
      <div
        className={`${styles.fboContainer} ${
          popup ? styles.fboContainerActive : ''
        }`}
      >
        <div className={styles.fboHead}>
          <b>{spanish ? '¡Bienvenido!' : 'Welcome!'}</b>
          <p>
            {spanish
              ? 'Estás comprando con el Empresario Independiente Forever especificado:'
              : 'You’re shopping with the Forever Business Owner below:'}
          </p>
        </div>
        <div className={styles.fboData}>
          <b>{spanish ? 'Nombre' : 'Name'}</b>
          <p>{referralInfo?.NombreFBO}</p>
          <b>FBO ID</b>
          <p>{referralInfo?.IdReferido}</p>
        </div>
      </div>
    </div>
  );
};

const Actions = ({ toggleSearchbox, cartData, hasFBO, referralInfo }) => (
  <div classame={styles.actions}>
    <SearchButton toggleSearchbox={toggleSearchbox} />
    {hasFBO && <FBO referralInfo={referralInfo} />}
    <MiniCart data={cartData} />
  </div>
);

const HeaderMobile = ({
  storeSelect,
  handleStoreSelect,
  toggleMenu,
  handleMenu,
  getSelectedStore,
  selectedStore,
}) => {
  const cartData = useSelector(
    (globalState) => globalState.cartInfo.InfoCarrito
  );
  const [referralInfo, setReferralInfo] = useState(null);
  const [hasFBO, setHasFBO] = useState(false);
  const referalId = useSelector(
    (globalState) => globalState.referralInfo.referralId
  );
  const getReferralInfo = useCallback(async () => {
    const payload = {
      Cliente: Config.api_services.client,
      Pais: 'MEX',
      Ambiente: Config.api_services.environment,
      IdFbo: referalId,
    };
    const resp = await ApiReferral.validateReferral(payload);
    if (resp.Codigo === 200) {
      setReferralInfo(resp.Respuesta[0]);
    }
  });

  useEffect(async () => {
    if (referalId) {
      setHasFBO(true);
      getReferralInfo();
    }
  }, [referalId]);
  return (
    <div className={styles.mobile}>
      <div className={styles.mobileContent}>
        <div className={styles.mobileLeft}>
          <button
            type="button"
            className={styles.mobileMenu}
            onClick={handleMenu}
          >
            <MenuIcon />
          </button>
        </div>
        <div className={styles.mobileCenter}>
          <LinkLang to="/home" className={styles.logo}>
            <Logo />
          </LinkLang>
          <StoreSelectorButton
            handleStoreSelect={handleStoreSelect}
            selectedStore={selectedStore}
          />
          <StoreSelectorModal
            active={storeSelect}
            handleStoreSelect={handleStoreSelect}
            getSelectedStore={getSelectedStore}
            selectedStore={selectedStore}
          />
        </div>
        <div className={styles.mobileRight}>
          {hasFBO && <FBO referralInfo={referralInfo} />}
          <MiniCart data={cartData[0]} />
        </div>
        <FboStore />
      </div>
      <Menu active={toggleMenu} toggle={handleMenu} />
    </div>
  );
};

const HeaderDesktop = ({
  storeSelect,
  handleStoreSelect,
  showSearch,
  toggleSearchbox,
  hideSearchbox,
  getSelectedStore,
  selectedStore,
}) => {
  const [login, setLogin] = useState(null);
  const [referralInfo, setReferralInfo] = useState(null);
  const [hasFBO, setHasFBO] = useState(false);
  const cartData = useSelector(
    (globalState) => globalState.cartInfo.InfoCarrito
  );
  const storeSelection = useSelector(
    (globalState) => globalState.estadoSelection.selectedEstadoId
  );

  const referalId = useSelector(
    (globalState) => globalState.referralInfo.referralId
  );

  const getReferralInfo = useCallback(async () => {
    const payload = {
      Cliente: Config.api_services.client,
      Pais: 'MEX',
      Ambiente: Config.api_services.environment,
      IdFbo: referalId,
    };
    const resp = await ApiReferral.validateReferral(payload);
    if (resp.Codigo === 200) {
      setReferralInfo(resp.Respuesta[0]);
    }
  });

  useEffect(async () => {
    setLogin(await apiLogin.getLogin());
    if (referalId) {
      setHasFBO(true);
      getReferralInfo();
    }
  }, [referalId]);
  return (
    <div className={styles.desktop}>
      <div className={styles.desktopContent}>
        <div className={styles.desktopContentTop}>
          <Language />
          <a
            href={login?.LoginURL}
            target="_blank"
            rel="noopener noreferrer"
            className={styles.desktopLogin}
          >
            {spanish ? login?.LoginSpanish : login?.LoginEnglish}
          </a>
        </div>
        <div className={styles.desktopContentMiddle}>
          <LinkLang to="/home" className={styles.logo}>
            <Logo />
          </LinkLang>
          <StoreSelectorButton
            handleStoreSelect={handleStoreSelect}
            selectedStore={selectedStore}
          />
          {storeSelection || storeSelect ? (
            <StoreSelectorModal
              active={storeSelect}
              handleStoreSelect={handleStoreSelect}
              getSelectedStore={getSelectedStore}
              selectedStore={selectedStore}
            />
          ) : null}
        </div>
        <div className={styles.desktopContentBottom}>
          <Navigation />
          <Actions
            toggleSearchbox={toggleSearchbox}
            hideSearchbox={hideSearchbox}
            cartData={cartData[0]}
            referralInfo={referralInfo}
            hasFBO={hasFBO}
          />
          <FboStore />
        </div>
      </div>
      <div className={styles.desktopOverlay}>
        <SearchBox active={showSearch} hideSearchbox={hideSearchbox} />
      </div>
    </div>
  );
};

class Header extends Component {
  state = {
    isDesktop: undefined,
    storeSelect: false,
    showSearch: false,
    toggleMenu: false,
    subMenu: '',
    selectedStore: 'Sucursal',
  };

  componentDidMount = () => {
    this.getViewport();
    const { selectedEstado } = this.props;
    const localDataEstado = JSON.parse(
      sessionStorage.getItem('localDataEstado')
    );
    window.addEventListener('resize', this.getViewport);
    if (!selectedEstado.selectedEstadoId && !localDataEstado)
      this.setState({ storeSelect: true });
    if (localDataEstado)
      this.setState({ selectedStore: localDataEstado.Estado });
    if (selectedEstado)
      this.setState({ selectedStore: selectedEstado.selectedEstadoName });
  };

  getViewport = () => {
    if (window.innerWidth > 1025) {
      this.setState({ isDesktop: true });
    } else {
      this.setState({ isDesktop: false });
    }
  };

  handleStoreSelect = (e) => {
    e.preventDefault();
    const { storeSelect } = this.state;
    this.setState({ storeSelect: !storeSelect });
    ga4.event({
      action: 'estado_selected',
      Category: 'estado_category',
      label: 'estado_label',
      value: storeSelect,
    });
  };

  getSelectedStore = (name) => {
    this.setState({ selectedStore: name });
  };

  toggleSearchbox = () => {
    const { showSearch } = this.state;
    this.setState({ showSearch: !showSearch });
  };

  hideSearchbox = () => {
    this.setState({ showSearch: false });
  };

  handleMenu = () => {
    const { toggleMenu } = this.state;
    this.setState({ toggleMenu: !toggleMenu });
  };

  render() {
    const {
      isDesktop,
      storeSelect,
      showSearch,
      toggleMenu,
      subMenu,
      selectedStore,
    } = this.state;
    return (
      <div className={styles.container}>
        <div className={styles.header}>
          {isDesktop ? (
            <HeaderDesktop
              storeSelect={storeSelect}
              handleStoreSelect={this.handleStoreSelect}
              showSearch={showSearch}
              toggleSearchbox={this.toggleSearchbox}
              hideSearchbox={this.hideSearchbox}
              subMenu={subMenu}
              getSelectedStore={this.getSelectedStore}
              selectedStore={selectedStore}
            />
          ) : (
            <HeaderMobile
              storeSelect={storeSelect}
              handleStoreSelect={this.handleStoreSelect}
              toggleMenu={toggleMenu}
              handleMenu={this.handleMenu}
              getSelectedStore={this.getSelectedStore}
              selectedStore={selectedStore}
            />
          )}
        </div>
      </div>
    );
  }
}

const mapStateToProps = (state) => ({
  selectedEstado: state.estadoSelection,
});

export default connect(mapStateToProps)(Header);
